import { useMemo } from "react";

export const DOTS = "...";

const range = (start, end) => {
    let length = end - start + 1;
    return Array.from({ length }, (_, idx) => idx + start);
};

export const usePagination = ({ totalPages, siblingCount = 1, currentPage, blockSize = 10 }) => {
    return useMemo(() => {
        const firstPageIndex = 1;
        const lastPageIndex = totalPages;

        // 현재 페이지가 속한 블록의 시작과 끝 페이지 계산
        const startPage = Math.floor((currentPage - 1) / blockSize) * blockSize + 1;
        const endPage = Math.min(startPage + blockSize - 1, totalPages);

        // 현재 블록의 페이지 번호 배열 생성 (e.g., [11, 12, ... 20])
        const pageRange = range(startPage, endPage);

        // 앞/뒤 ... 및 첫/마지막 페이지 추가 로직
        let finalRange = [...pageRange];

        // --- 왼쪽 로직 ---
        const shouldShowLeftDots = startPage > 2;
        const shouldShowFirstPage = startPage > 1;

        if (shouldShowLeftDots) {
            // (e.g.) startPage가 11일 때 -> [1, '...', ...pageRange]
            finalRange = [firstPageIndex, DOTS, ...finalRange];
        } else if (shouldShowFirstPage) {
            // (e.g.) startPage가 2일 때 (blockSize가 작을 경우) -> [1, ...pageRange]
            finalRange = [firstPageIndex, ...finalRange];
        }

        // --- 오른쪽 로직 ---
        const shouldShowRightDots = endPage < totalPages - 1;
        const shouldShowLastPage = endPage < totalPages;

        if (shouldShowRightDots) {
            // (e.g.) endPage가 10이고 totalPages가 30일 때 -> [...pageRange, '...', 30]
            finalRange = [...finalRange, DOTS, lastPageIndex];
        } else if (shouldShowLastPage) {
            // (e.g.) endPage가 10이고 totalPages가 11일 때 -> [...pageRange, 11]
            finalRange = [...finalRange, lastPageIndex];
        }

        return finalRange;
    }, [currentPage, totalPages, blockSize]);
};
